import React, { useState, useEffect } from "react";
import Lightbox from "yet-another-react-lightbox";
import { Slide } from "yet-another-react-lightbox";
import { motion } from "framer-motion";
import { MdOutlineAddToPhotos } from "react-icons/md";
import ModalActividadAgre from "../modal/ModalActividadAgre.tsx";
import { collection, addDoc, getDocs, Timestamp } from "firebase/firestore";
import { db } from "../components/Firebase.ts";
import "yet-another-react-lightbox/styles.css";

interface actividad {
  titulo: string;
  descripcion: string;
  imagenes: string[];
}

const Actividades: React.FC = () => {
  const [index, setIndex] = useState<number>(-1);
  const [imageneslightbox, setImageneslightbox] = useState<Slide[]>([]);
  const [actividad, setActividad] = useState<actividad[]>([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [nuevaActividad, setNuevaActividad] = useState<actividad>({
    titulo: "",
    descripcion: "",
    imagenes: [],
  });

  // Bloquea scroll al abrir modal
  useEffect(() => {
    document.body.style.overflow = modalOpen ? "hidden" : "auto";
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [modalOpen]);

  // Carga actividades al iniciar
  useEffect(() => {
    const fetchActividades = async () => {
      const querySnapshot = await getDocs(collection(db, "actividades"));
      const actividadesData: actividad[] = querySnapshot.docs.map((doc) => ({
        titulo: doc.data().titulo,
        descripcion: doc.data().descripcion,
        imagenes: doc.data().imagenes,
      }));
      setActividad(actividadesData);
    };

    fetchActividades();
  }, []);

  // Guarda en Firestore
  const guardarActividad = async (act: actividad) => {
    try {
      await addDoc(collection(db, "actividades"), {
        ...act,
        fecha: Timestamp.now(),
      });

      setActividad((prev) => [...prev, act]);
      setNuevaActividad({ titulo: "", descripcion: "", imagenes: [] });
      setModalOpen(false);
    } catch (error) {
      console.error("Error al guardar en Firestore:", error);
    }
  };

  return (
    <>
      <motion.div
        className="max-w-screen-lg mx-auto px-4 py-16 mt-8"
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, ease: "easeOut" }}
      >
        <div className={`p-6 max-w-6xl mx-auto ${modalOpen ? "blur-sm" : ""}`}>
          <h1 className="text-3xl font-bold text-center text-blue-700 mb-10">
            Actividades
          </h1>

          <div className="flex justify-end mb-8 text-4xl">
            <div
              className="cursor-pointer text-pink-600 hover:text-pink-300 transition-colors"
              onClick={() => setModalOpen(true)}
            >
              <MdOutlineAddToPhotos />
            </div>
          </div>

          <div className="grid md:grid-cols-3 gap-8">
            {actividad.map((actividad, i) => (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, ease: "easeOut", delay: i * 0.2 }}
                className="group cursor-pointer rounded-xl overflow-hidden shadow-lg border transition-transform duration-300 transform hover:scale-105"
                onClick={() => {
                  setImageneslightbox(
                    actividad.imagenes.map((img) => ({ src: img }))
                  );
                  setIndex(0);
                }}
              >
                <img
                  src={actividad.imagenes[0]}
                  alt={actividad.titulo}
                  className="w-full h-64 object-cover group-hover:scale-110 transition duration-300"
                />
                <div className="p-4 bg-white">
                  <h2 className="text-xl font-semibold text-blue-800">
                    {actividad.titulo}
                  </h2>
                  <p className="text-gray-600 text-sm mt-2">
                    {actividad.descripcion}
                  </p>
                </div>
              </motion.div>
            ))}
          </div>

          <Lightbox
            open={index >= 0}
            close={() => setIndex(-1)}
            slides={imageneslightbox}
            index={index}
          />
        </div>
      </motion.div>

      <ModalActividadAgre
        isOpen={modalOpen}
        onClose={() => setModalOpen(false)}
        onSave={guardarActividad}
        actividad={nuevaActividad}
        setActividad={setNuevaActividad}
      />
    </>
  );
};

export default Actividades;
